
import 'quasar/dist/quasar.css'
import lang from 'quasar/lang/ru.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import QBadge from 'quasar/src/components/badge/QBadge.js';;

// To be used on app.use(Quasar, { ... })
export default {
  config: {
  },
  plugins: {
    QBadge
  },
  lang: lang,

}